export interface AppPlatformConfig {
  id: string;
  version: string;
  fileSize: string;
  universalSize?: string;
  releaseDate: string;
  requirementsKey: string;
  href: string;
  color: string;
  bgGradient: string;
  borderColor: string;
  badgeColor: string;
  badge: string;
  hoverShadow: string;
  textColor?: string;
  ctaColor?: string;
  padding: string;
}

export const MOBILE_APPS: AppPlatformConfig[] = [
  {
    id: 'android',
    version: '5.2.3',
    fileSize: '~200 MB',
    universalSize: '399 MB',
    releaseDate: '24 July 2026',
    requirementsKey: 'download.mobile.androidReq',
    href: 'https://play.google.com/store/apps/details?id=com.eschoolcambodia.app',
    color: '#3ddc84',
    bgGradient: 'from-[#3ddc84]/10 to-[#3ddc84]/5',
    borderColor: 'border-[#3ddc84]/30',
    badgeColor: 'bg-[#3ddc84]/15 text-[#2d9e60]',
    badge: 'Google Play',
    hoverShadow: 'hover:shadow-[#3ddc84]/10',
    ctaColor: 'text-[#2d9e60]',
    padding: 'p-2',
  },
  {
    id: 'ios',
    version: '2.5.2',
    fileSize: '~35 MB',
    universalSize: '68 MB',
    releaseDate: '24 July 2026',
    requirementsKey: 'download.mobile.iosReq',
    href: 'https://itunes.apple.com/us/app/e-school-cambodia/id1436282967?ls=1&mt=8',
    color: '#555',
    bgGradient: 'from-[#aaa]/10 to-[#aaa]/5',
    borderColor: 'border-gray-200',
    badgeColor: 'bg-gray-100 text-gray-600',
    badge: 'App Store',
    hoverShadow: 'hover:shadow-gray-200/60',
    ctaColor: 'text-gray-700',
    padding: 'p-2.5',
  },
  {
    id: 'huawei',
    version: '5.2.3',
    fileSize: '~170 MB',
    universalSize: '338 MB',
    releaseDate: '13 August 2026',
    requirementsKey: 'download.mobile.huaweiReq',
    href: 'https://appgallery.huawei.com/#/app/C102370101',
    color: '#cf0a2c',
    bgGradient: 'from-[#cf0a2c]/10 to-[#cf0a2c]/5',
    borderColor: 'border-[#cf0a2c]/20',
    badgeColor: 'bg-[#cf0a2c]/10 text-[#cf0a2c]',
    badge: 'App Gallery',
    hoverShadow: 'hover:shadow-[#cf0a2c]/10',
    ctaColor: 'text-[#cf0a2c]',
    padding: 'p-2',
  },
];
export const DESKTOP_APPS: AppPlatformConfig[] = [
  {
    id: 'windows',
    version: '3.2.0',
    fileSize: '95 MB',
    releaseDate: '24 June 2026',
    requirementsKey: 'download.desktop.windowsReq',
    href: '/download/windows',
    color: '#0078d4',
    bgGradient: 'from-[#0078d4]/10 to-[#0078d4]/5',
    borderColor: 'border-[#0078d4]/30',
    badgeColor: 'bg-[#0078d4]/10 text-[#0078d4]',
    badge: 'Windows x64',
    hoverShadow: 'hover:shadow-[#0078d4]/15',
    textColor: 'text-[#0078d4]',
    padding: 'p-2',
  },
  {
    id: 'windows-arm',
    version: '3.2.0',
    fileSize: '92 MB',
    releaseDate: '24 June 2026',
    requirementsKey: 'download.desktop.windowsArmReq',
    href: '/download/windows-arm64',
    color: '#0078d4',
    bgGradient: 'from-[#0078d4]/10 to-[#0078d4]/5',
    borderColor: 'border-[#0078d4]/30',
    badgeColor: 'bg-[#0078d4]/10 text-[#0078d4]',
    badge: 'Windows ARM64',
    hoverShadow: 'hover:shadow-[#0078d4]/15',
    textColor: 'text-[#0078d4]',
    padding: 'p-2',
  },
  {
    id: 'linux',
    version: '3.2.0',
    fileSize: '110 MB',
    releaseDate: '24 June 2026',
    requirementsKey: 'download.desktop.linuxReq',
    href: '/download/linux',
    color: '#e95420',
    bgGradient: 'from-[#e95420]/10 to-[#e95420]/5',
    borderColor: 'border-[#e95420]/30',
    badgeColor: 'bg-[#e95420]/10 text-[#e95420]',
    badge: 'Linux',
    hoverShadow: 'hover:shadow-[#e95420]/15',
    textColor: 'text-[#e95420]',
    padding: 'p-1.5',
  },
  {
    id: 'mac-arm',
    version: '3.2.0',
    fileSize: '98 MB',
    releaseDate: '24 June 2026',
    requirementsKey: 'download.desktop.macArmReq',
    href: '/download/mac-arm64',
    color: '#555',
    bgGradient: 'from-gray-100 to-gray-50',
    borderColor: 'border-gray-200',
    badgeColor: 'bg-gray-100 text-gray-600',
    badge: 'macOS ARM64',
    hoverShadow: 'hover:shadow-gray-200/80',
    textColor: 'text-gray-600',
    padding: 'p-2.5',
  },
  {
    id: 'mac-x64',
    version: '3.2.0',
    fileSize: '102 MB',
    releaseDate: '24 June 2026',
    requirementsKey: 'download.desktop.macX64Req',
    href: '/download/mac-x64',
    color: '#555',
    bgGradient: 'from-gray-100 to-gray-50',
    borderColor: 'border-gray-200',
    badgeColor: 'bg-gray-100 text-gray-600',
    badge: 'macOS x64',
    hoverShadow: 'hover:shadow-gray-200/80',
    textColor: 'text-gray-600',
    padding: 'p-2.5',
  },
];
